/**
 * Pre-compiled es messages for SplitButton
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { noActionsAvailable: `No hay acciones disponibles` };
